<div [ngClass]="backgroundColor()" class="tw-rounded-3 tw-mx-4 tw-mt-3 tw-overflow-hidden">
  <!-- Header: user info + cover image -->
  <div class="tw-flex tw-items-start">
    <div class="tw-flex-[45] tw-pl-4 tw-pt-5">
      <p class="tw-font-body tw-font-normal tw-text-50 tw-text-gray-500">
        <span class="tw-capitalize">{{patientName()}}</span>, {{patientAge()}} yrs
      </p>
      @if (displayConcernName()) {
        <p class="tw-font-bold tw-font-lexend tw-text-400 tw-text-gray-800 tw-capitalize">
          <span i18n="@@treatmentForDisplayConcern">Treatment for {{displayConcernName()}}</span>
        </p>
      } @else if (isFaceRegimen()) {
        <p class="tw-font-bold tw-font-lexend tw-text-400 tw-text-gray-800 tw-capitalize" i18n="@@treatmentForSkin"> Treatment for Skin </p>
      } @else {
        <p class="tw-font-bold tw-font-lexend tw-text-400 tw-text-gray-800 tw-capitalize" i18n="@@treatmentForHair"> Treatment for Hair </p>
      }
    </div>
    <div class="tw-flex-[55] tw-pt-2">
      <img class="tw-w-full tw-h-full tw-object-contain" [src]="regimenCoverImage()" alt="regimen_cover" />
    </div>
  </div>

  <!-- Plan includes list -->
  <div class="tw-relative tw-bg-white tw-rounded-3 tw-mx-2 tw-mb-4 tw-pt-6 tw-pb-4 tw-px-2 tw-z-10">
    <div class="tw-absolute tw-top-0 tw-left-2 -tw-translate-y-1/2 tw-px-2 tw-py-[2.5px] tw-bg-green-500 tw-rounded-2.5 tw-overflow-hidden ">
      <p class="tw-font-body tw-font-normal tw-text-100 tw-text-white" i18n="@@yourPlanIncludes">Your Plan includes</p>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-3">
      @for (item of currentPlanInfo().items; track item.id) {
        <div class="tw-flex tw-items-center tw-gap-1.5">
          <cs-icon class="tw-w-3.5 tw-h-3.5 tw-text-green-500 tw-flex-shrink-0" [iconName]="'green_tick_circle'"></cs-icon>
          @if (item.id === planInfoItemId.PRODUCTS) {
            <p class="tw-text-300 tw-leading-none tw-font-lexend tw-font-normal tw-text-gray-600" i18n="@@PRODUCT_TREATMENT_KIT_WITH_COUNT">{{ regimenProductsLength() }} product Treatment Kit</p>
          } @else if (item.id === planInfoItemId.MONEY_BACK_GUARANTEE) {
            <p class="tw-text-300 tw-leading-none tw-font-lexend tw-font-semibold tw-text-gray-800 tw-uppercase">
              <span i18n="@@money_back">100% Money Back</span>&nbsp;<span class="tw-text-brown-700" i18n="@@guarantee">guarantee</span>
            </p>
          } @else {
            <p class="tw-text-300 tw-leading-none tw-font-lexend tw-font-normal tw-text-gray-600">{{item.title}}</p>
          }
        </div>
      }
    </div>
  </div>
</div>
